var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-3 px-3"},[_c('p',[_vm._v(_vm._s(_vm.$t('home.notFound')))])])}
var staticRenderFns = []

export { render, staticRenderFns }